// app/app.config.ts
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { provideRouter, withComponentInputBinding, withRouterConfig, RouteReuseStrategy, ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

export class CustomRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    // If the route data has 'shouldRecreate' set to true, do NOT reuse the component
    if (future.routeConfig?.data?.['shouldRecreate']) {
      return false;
    }
    return super.shouldReuseRoute(future, curr);
  }
}

import { provideAnimations } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPermissionsModule } from 'ngx-permissions';
import { CUSTOM_PROVIDERS } from './core.providers';
import { CldrIntlService } from '@progress/kendo-angular-intl';
import { spinnerInterceptor } from '@interceptors/spinner.interceptor';
import { stringToDateInterceptor } from '@interceptors/string-to-date.interceptor';
import { ROUTES } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpClient(
      withInterceptors([spinnerInterceptor, stringToDateInterceptor]),
      withInterceptorsFromDi(),
      withFetch()
    ), // Use fetch API for better performance
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      ROUTES, 
      withComponentInputBinding(),
      withRouterConfig({ onSameUrlNavigation: 'reload' })
    ),
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    importProvidersFrom(NgbModule, NgxPermissionsModule.forRoot(), TranslateModule.forRoot()),
    CUSTOM_PROVIDERS,
    CldrIntlService,
  ],
};
